import { NgModule } from "@angular/core";
import { CommonPackageModule } from "src/app/modules/common-package.module";
import { UserManagerComponent } from "./user-manager.component";

@NgModule({
    declarations: [UserManagerComponent],
    imports: [CommonPackageModule],
    exports: [UserManagerComponent],
})
export class UserManagerModule{}